module.exports = __webpack_public_path__ + "wechat.svg?92032417a3466fe75610f2a767a9be8c";